import { render, staticRenderFns } from "./bf-overlay.vue?vue&type=template&id=5ae836fc&scoped=true&lang=pug&"
import script from "./bf-overlay.vue?vue&type=script&lang=js&"
export * from "./bf-overlay.vue?vue&type=script&lang=js&"
import style0 from "./bf-overlay.vue?vue&type=style&index=0&id=5ae836fc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae836fc",
  null
  
)

export default component.exports